import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/assets/logo.png" alt="Tallhaven" className="footer-logo-img" />
              <span className="footer-logo-text">Tallhaven</span>
            </div>
            <p className="footer-description">
              Building innovative software solutions for the modern world. 
              Your trusted partner in digital transformation.
            </p>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Web Development</a></li>
              <li><a href="#services">Mobile Apps</a></li>
              <li><a href="#services">Cloud Solutions</a></li>
              <li><a href="#services">AI & ML</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/t&c">Terms &amp; Conditions</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-links">
              <a href="#" aria-label="LinkedIn">💼</a>
              <a href="#" aria-label="Twitter">🐦</a>
              <a href="#" aria-label="GitHub">👨‍💻</a>
              <a href="#" aria-label="Email">📧</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Tallhaven. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;